module.exports = __webpack_public_path__ + "static/media/py.b0149939.svg";